import { gql } from '@apollo/client'

export const GET_RECENTS_OWNED_TOPICS = gql`
  query getRecentsOwnedTopics($pagination: PaginationInput) {
    listSavedPostSearchesPaginated(pagination: $pagination) {
      entities {
        id
        territoryId
        name
        filters
        updatedAt
      }
    }
  }
`
